/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    CLEAN_LIST_PAYMENT_HISTORY,
    LOAD_LIST_PAYMENT_HISTORY_FAIL,
    LOAD_LIST_PAYMENT_HISTORY_REQUEST,
    LOAD_LIST_PAYMENT_HISTORY_SUCCESS,
} from './widgetPaymentHistoryConstants';
import { IWidgetPaymentHistoryReducer, WidgetPaymentHistoryTypes } from './widgetPaymentHistoryTypes';

export const widgetPaymentHistoryInitialState: IWidgetPaymentHistoryReducer =
    {
        error: '',
        loading: true,
        payments: [],
    };

const widgetPaymentHistoryReducer: Reducer<IWidgetPaymentHistoryReducer, WidgetPaymentHistoryTypes> =
    (
        state: IWidgetPaymentHistoryReducer = widgetPaymentHistoryInitialState,
        action: WidgetPaymentHistoryTypes,
    ) =>
        produce(state, draft => {
            switch (action.type) {
                case LOAD_LIST_PAYMENT_HISTORY_REQUEST:
                    draft.loading = true;
                    break;
                case LOAD_LIST_PAYMENT_HISTORY_SUCCESS:
                    draft.loading = false;
                    draft.payments = action.payload;
                    break;
                case LOAD_LIST_PAYMENT_HISTORY_FAIL:
                    draft.error = action.payload;
                    draft.loading = false;
                    break;
                case CLEAN_LIST_PAYMENT_HISTORY:
                    draft.error = '';
                    draft.payments = [];
                    break;
            }
        });

export default widgetPaymentHistoryReducer;
